import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { CDCCVX } from '../../models/cdc-cvx';
import { getCDCCVXs } from '../../apis/emr-data';

export interface State {
    allIds: number[];
    byId: Dictionary<CDCCVX>;
    loading: Dictionary<boolean>;
}

export const cdcCVXs = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: CDCCVX[],
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                const byId = {
                    ...state.byId,
                    ...storeByCVXCode(data)
                };
                return {
                    ...state,
                    allIds: Object.keys(byId).map(x => +x),
                    byId: byId,
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getCDCCVXsAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (selectors.getCDCCVXIds(rootState.cdcCVXs).length === 0) {
                try {
                    const data = await getCDCCVXs();
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});

const storeByCVXCode = (data: Undefinable<MixType<CDCCVX>>): Dictionary<CDCCVX> => {
    if (data) {
        if (Array.isArray(data)) {
            return data.reduce(
                (prev, x) => {
                    prev[x.cvxCode] = x;
                    return prev;
                },
                {} as Dictionary<CDCCVX>
            );
        } else {
            return {
                [data.cvxCode]: data
            } as Dictionary<CDCCVX>;
        }
    } else {
        return {} as Dictionary<CDCCVX>;
    }
};
